import Shell from '../components/Shell';
import { C2Section } from '../components/c2';
import type { DecorShape } from '../components/c2/Section';
import PageHero from '../components/secondary/PageHero';
import BottomCTA from '../components/secondary/BottomCTA';
import BrowserMockWithPopup from '../components/extension/BrowserMockWithPopup';

const browserMockDecor: DecorShape[] = [
  { shape: 'circle', size: 240, color: 'sky', style: { position: 'absolute', top: 60, left: -100, opacity: 0.45 } },
  { shape: 'pill', size: 240, color: 'lemon', style: { position: 'absolute', top: 200, right: -80, opacity: 0.45, transform: 'rotate(8deg)' } },
  { shape: 'square', size: 140, color: 'peach', style: { position: 'absolute', bottom: 80, left: '10%', opacity: 0.45, transform: 'rotate(-10deg)' } },
  { shape: 'circle', size: 180, color: 'mint', style: { position: 'absolute', bottom: 40, right: -50, opacity: 0.45 } },
];

export default function ExtensionPage() {
  return (
    <Shell>
      <PageHero
        title="Create go/ links in a tidy Chrome extension"
        titleAccentWord="tidy Chrome extension"
        decorShapes={[
          { shape: 'circle', size: 300, color: 'lilac', style: { position: 'absolute', top: -40, left: -60, opacity: 0.5 } },
          { shape: 'circle', size: 200, color: 'peach', style: { position: 'absolute', top: 80, right: -40, opacity: 0.55 } },
          { shape: 'pill', size: 220, color: 'mint', style: { position: 'absolute', bottom: 10, right: '30%', opacity: 0.5, transform: 'rotate(10deg)' } },
        ]}
      />

      <C2Section pad={0} style={{ paddingBottom: 80 }} decor={browserMockDecor}>
        <div className="max-w-[1200px] mx-auto">
          <BrowserMockWithPopup variant="create" initialName="vacation" />
        </div>
      </C2Section>

      <BottomCTA
        title="Add to Chrome in 10 seconds"
        titleAccent="10 seconds"
        sub="Works on Chrome and any Chromium-based browser. Firefox coming soon. Open-source on GitHub."
        primaryLabel="Add to Chrome →"
        primaryHref="https://chromewebstore.google.com/detail/tidy-go-links/nijbmhklldgocejmopojcapjiacnepja"
      />
    </Shell>
  );
}
